export interface Theme {
  key?: string | null;
  name: string;
}
